var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dromo-test chemtracker-module"
  }, [_c('div', [_c('VActionButton', {
    attrs: {
      "show-badge": false,
      "show-icon": false,
      "label": "Test import"
    },
    on: {
      "click": _vm.startImport
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v("Data: " + _vm._s(_vm.dromoResultsData))]), _vm._v(" "), _c('div', {
    staticClass: "metadata"
  }, [_vm._v("Metadata: " + _vm._s(_vm.dromoResultsMetadata))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }